<div class="ct-faq-container" *ngIf="set1.length > 0">
  <h2>{{category | slugText : 'capitalize'}} FAQs</h2>
  <mat-accordion class="ct-faq-list">
    <div class="set">
      <ng-container *ngFor="let item of set1">
        <mat-expansion-panel hideToggle class="faq-item">
          <mat-expansion-panel-header class="faq-item-header">
            {{item.ques}}
          </mat-expansion-panel-header>
          <ng-container *ngFor="let resp of item.response">
            <p class="faq-content" [innerHTML]="resp"></p>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </div>
    <div class="set" *ngIf="set2 && set2.length > 0">
      <ng-container *ngFor="let item of set2">
        <mat-expansion-panel hideToggle class="faq-item">
          <mat-expansion-panel-header class="faq-item-header">
            {{item.ques}}
          </mat-expansion-panel-header>
          <ng-container *ngFor="let resp of item.response">
            <p class="faq-content" [innerHTML]="resp"></p>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </div>
  </mat-accordion>
</div>